import React from 'react';
import { formatMoney } from 'utils/utils';

const Td: React.FC<any> = (props): JSX.Element =>
    <td>
        R$ {formatMoney(props.value)}
    </td>

export default React.memo(Td);
